// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type FileDescriptorId,
  FileDescriptorIdFromJSON,
  FileDescriptorIdToJSON,
} from "../models/FileDescriptorId";
import {
  type FileDescriptorId1,
  FileDescriptorId1FromJSON,
  FileDescriptorId1ToJSON,
} from "../models/FileDescriptorId1";
import {
  type RasterCreateOptions,
  RasterCreateOptionsFromJSON,
  RasterCreateOptionsToJSON,
} from "../models/RasterCreateOptions";
import { type RasterId, RasterIdFromJSON, RasterIdToJSON } from "../models/RasterId";
import {
  type ResponseStartTask,
  ResponseStartTaskFromJSON,
  ResponseStartTaskToJSON,
} from "../models/ResponseStartTask";
import {
  type ScenarioAttachment,
  ScenarioAttachmentFromJSON,
  ScenarioAttachmentToJSON,
} from "../models/ScenarioAttachment";
import {
  type ScenarioAttachmentCreate,
  ScenarioAttachmentCreateFromJSON,
  ScenarioAttachmentCreateToJSON,
} from "../models/ScenarioAttachmentCreate";
import { type TaskId, TaskIdFromJSON, TaskIdToJSON } from "../models/TaskId";
import { type TaskId1, TaskId1FromJSON, TaskId1ToJSON } from "../models/TaskId1";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface JobScenarioAttachmentCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  scenarioAttachmentCreate: ScenarioAttachmentCreate;
}

export interface JobScenarioAttachmentDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  attachmentId: number;
  /**
   *
   */
  xJobSecret: string;
}

export interface JobScenarioAttachmentRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  attachmentId: number;
  /**
   *
   */
  xJobSecret: string;
}

export interface JobTaskResultRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  taskId: TaskId;
  /**
   *
   */
  xJobSecret: string;
}

export interface RasterDataTaskResultRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: FileDescriptorId;
  /**
   *
   */
  taskId: TaskId1;
}

export interface ScenarioCreateAttachmentRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  scenarioAttachmentCreate: ScenarioAttachmentCreate;
}

export interface ScenarioDeleteAttachmentRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  attachmentId: number;
}

export interface ScenarioRetrieveAttachmentRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  attachmentId: number;
}

export interface StartTaskRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: FileDescriptorId1;
  /**
   *
   */
  rasterId: RasterId;
  /**
   *
   */
  rasterCreateOptions: RasterCreateOptions;
}

/**
 *
 */
export class ScenariosApi extends runtime.BaseAPI {
  /**
   * Creates request options for jobScenarioAttachmentCreate without sending the request
   */
  async jobScenarioAttachmentCreateRequestOpts(
    requestParameters: JobScenarioAttachmentCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobScenarioAttachmentCreate().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobScenarioAttachmentCreate().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling jobScenarioAttachmentCreate().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobScenarioAttachmentCreate().'
      );
    }

    if (requestParameters["scenarioAttachmentCreate"] == null) {
      throw new runtime.RequiredError(
        "scenarioAttachmentCreate",
        'Required parameter "scenarioAttachmentCreate" was null or undefined when calling jobScenarioAttachmentCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/file-descriptors/{file_descriptor_id}/scenario-attachments`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ScenarioAttachmentCreateToJSON(requestParameters["scenarioAttachmentCreate"]),
    };
  }

  /**
   * Create a new scenario attachment from a job
   */
  async jobScenarioAttachmentCreateRaw(
    requestParameters: JobScenarioAttachmentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ScenarioAttachment>> {
    const requestOptions = await this.jobScenarioAttachmentCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ScenarioAttachmentFromJSON(jsonValue)
    );
  }

  /**
   * Create a new scenario attachment from a job
   */
  async jobScenarioAttachmentCreate(
    requestParameters: JobScenarioAttachmentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ScenarioAttachment> {
    const response = await this.jobScenarioAttachmentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobScenarioAttachmentDelete without sending the request
   */
  async jobScenarioAttachmentDeleteRequestOpts(
    requestParameters: JobScenarioAttachmentDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobScenarioAttachmentDelete().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobScenarioAttachmentDelete().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling jobScenarioAttachmentDelete().'
      );
    }

    if (requestParameters["attachmentId"] == null) {
      throw new runtime.RequiredError(
        "attachmentId",
        'Required parameter "attachmentId" was null or undefined when calling jobScenarioAttachmentDelete().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobScenarioAttachmentDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/file-descriptors/{file_descriptor_id}/scenario-attachments/{attachment_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{attachment_id}",
      encodeURIComponent(String(requestParameters["attachmentId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a specific scenario attachment from a job
   */
  async jobScenarioAttachmentDeleteRaw(
    requestParameters: JobScenarioAttachmentDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.jobScenarioAttachmentDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a specific scenario attachment from a job
   */
  async jobScenarioAttachmentDelete(
    requestParameters: JobScenarioAttachmentDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.jobScenarioAttachmentDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for jobScenarioAttachmentRetrieve without sending the request
   */
  async jobScenarioAttachmentRetrieveRequestOpts(
    requestParameters: JobScenarioAttachmentRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobScenarioAttachmentRetrieve().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobScenarioAttachmentRetrieve().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling jobScenarioAttachmentRetrieve().'
      );
    }

    if (requestParameters["attachmentId"] == null) {
      throw new runtime.RequiredError(
        "attachmentId",
        'Required parameter "attachmentId" was null or undefined when calling jobScenarioAttachmentRetrieve().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobScenarioAttachmentRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/file-descriptors/{file_descriptor_id}/scenario-attachments/{attachment_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{attachment_id}",
      encodeURIComponent(String(requestParameters["attachmentId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Fetch a specific scenario attachment from a job
   */
  async jobScenarioAttachmentRetrieveRaw(
    requestParameters: JobScenarioAttachmentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ScenarioAttachment>> {
    const requestOptions = await this.jobScenarioAttachmentRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ScenarioAttachmentFromJSON(jsonValue)
    );
  }

  /**
   * Fetch a specific scenario attachment from a job
   */
  async jobScenarioAttachmentRetrieve(
    requestParameters: JobScenarioAttachmentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ScenarioAttachment> {
    const response = await this.jobScenarioAttachmentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobTaskResult without sending the request
   */
  async jobTaskResultRequestOpts(
    requestParameters: JobTaskResultRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobTaskResult().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobTaskResult().'
      );
    }

    if (requestParameters["taskId"] == null) {
      throw new runtime.RequiredError(
        "taskId",
        'Required parameter "taskId" was null or undefined when calling jobTaskResult().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobTaskResult().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/file-descriptors/{file_descriptor_id}/task/{task_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace("{task_id}", encodeURIComponent(String(requestParameters["taskId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Fetch the result of a task from a job
   */
  async jobTaskResultRaw(
    requestParameters: JobTaskResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.jobTaskResultRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Fetch the result of a task from a job
   */
  async jobTaskResult(
    requestParameters: JobTaskResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.jobTaskResultRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for rasterDataTaskResult without sending the request
   */
  async rasterDataTaskResultRequestOpts(
    requestParameters: RasterDataTaskResultRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling rasterDataTaskResult().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling rasterDataTaskResult().'
      );
    }

    if (requestParameters["taskId"] == null) {
      throw new runtime.RequiredError(
        "taskId",
        'Required parameter "taskId" was null or undefined when calling rasterDataTaskResult().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/raster/{raster_id}/task/{task_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace("{task_id}", encodeURIComponent(String(requestParameters["taskId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Fetch the result of a generate raster task
   */
  async rasterDataTaskResultRaw(
    requestParameters: RasterDataTaskResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.rasterDataTaskResultRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Fetch the result of a generate raster task
   */
  async rasterDataTaskResult(
    requestParameters: RasterDataTaskResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.rasterDataTaskResultRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for scenarioCreateAttachment without sending the request
   */
  async scenarioCreateAttachmentRequestOpts(
    requestParameters: ScenarioCreateAttachmentRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling scenarioCreateAttachment().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling scenarioCreateAttachment().'
      );
    }

    if (requestParameters["scenarioAttachmentCreate"] == null) {
      throw new runtime.RequiredError(
        "scenarioAttachmentCreate",
        'Required parameter "scenarioAttachmentCreate" was null or undefined when calling scenarioCreateAttachment().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/scenario-attachments`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ScenarioAttachmentCreateToJSON(requestParameters["scenarioAttachmentCreate"]),
    };
  }

  /**
   * Create a new scenario attachment
   */
  async scenarioCreateAttachmentRaw(
    requestParameters: ScenarioCreateAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ScenarioAttachment>> {
    const requestOptions = await this.scenarioCreateAttachmentRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ScenarioAttachmentFromJSON(jsonValue)
    );
  }

  /**
   * Create a new scenario attachment
   */
  async scenarioCreateAttachment(
    requestParameters: ScenarioCreateAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ScenarioAttachment> {
    const response = await this.scenarioCreateAttachmentRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for scenarioDeleteAttachment without sending the request
   */
  async scenarioDeleteAttachmentRequestOpts(
    requestParameters: ScenarioDeleteAttachmentRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling scenarioDeleteAttachment().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling scenarioDeleteAttachment().'
      );
    }

    if (requestParameters["attachmentId"] == null) {
      throw new runtime.RequiredError(
        "attachmentId",
        'Required parameter "attachmentId" was null or undefined when calling scenarioDeleteAttachment().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/scenario-attachments/{attachment_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{attachment_id}",
      encodeURIComponent(String(requestParameters["attachmentId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete an OGC 3D tile dataset
   */
  async scenarioDeleteAttachmentRaw(
    requestParameters: ScenarioDeleteAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.scenarioDeleteAttachmentRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete an OGC 3D tile dataset
   */
  async scenarioDeleteAttachment(
    requestParameters: ScenarioDeleteAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.scenarioDeleteAttachmentRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for scenarioRetrieveAttachment without sending the request
   */
  async scenarioRetrieveAttachmentRequestOpts(
    requestParameters: ScenarioRetrieveAttachmentRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling scenarioRetrieveAttachment().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling scenarioRetrieveAttachment().'
      );
    }

    if (requestParameters["attachmentId"] == null) {
      throw new runtime.RequiredError(
        "attachmentId",
        'Required parameter "attachmentId" was null or undefined when calling scenarioRetrieveAttachment().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/scenario-attachments/{attachment_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{attachment_id}",
      encodeURIComponent(String(requestParameters["attachmentId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Fetch a specific scenario attachment
   */
  async scenarioRetrieveAttachmentRaw(
    requestParameters: ScenarioRetrieveAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ScenarioAttachment>> {
    const requestOptions = await this.scenarioRetrieveAttachmentRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ScenarioAttachmentFromJSON(jsonValue)
    );
  }

  /**
   * Fetch a specific scenario attachment
   */
  async scenarioRetrieveAttachment(
    requestParameters: ScenarioRetrieveAttachmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ScenarioAttachment> {
    const response = await this.scenarioRetrieveAttachmentRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for startTask without sending the request
   */
  async startTaskRequestOpts(requestParameters: StartTaskRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling startTask().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling startTask().'
      );
    }

    if (requestParameters["rasterId"] == null) {
      throw new runtime.RequiredError(
        "rasterId",
        'Required parameter "rasterId" was null or undefined when calling startTask().'
      );
    }

    if (requestParameters["rasterCreateOptions"] == null) {
      throw new runtime.RequiredError(
        "rasterCreateOptions",
        'Required parameter "rasterCreateOptions" was null or undefined when calling startTask().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/raster/{raster_id}/task`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{raster_id}",
      encodeURIComponent(String(requestParameters["rasterId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RasterCreateOptionsToJSON(requestParameters["rasterCreateOptions"]),
    };
  }

  /**
   * Start a generate raster task
   */
  async startTaskRaw(
    requestParameters: StartTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResponseStartTask>> {
    const requestOptions = await this.startTaskRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResponseStartTaskFromJSON(jsonValue)
    );
  }

  /**
   * Start a generate raster task
   */
  async startTask(
    requestParameters: StartTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResponseStartTask> {
    const response = await this.startTaskRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
